import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ImageCropper from "../Common/ImageCropper";
import Upload from "../Common/upload-image/Upload";
import getCroppedImg from "../../helpers/CropImage";
import { Range, getTrackBackground } from "react-range";
import ImageKit from "imagekit-javascript";

const ImageCrop = (props) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [imageUrl, setImageUrl] = useState(null);
  const [zoom, setZoom] = useState([1]);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState({
    width: 100,
    height: 100,
  });
  const [cropImage, setCropImage] = useState(null);

  const imageKit = new ImageKit({
    publicKey: process.env.REACT_APP_PUBLIC_KEY,
    urlEndpoint: process.env.REACT_APP_URL_END_POINT,
    authenticationEndpoint: process.env.REACT_APP_AUTHENTICATION_END_POINT,
  });

  const handleImageUpload = async (croppedImage) => {
    if (croppedImage !== null) {
      await imageKit.upload(
        {
          file: croppedImage,
          fileName: `cropped_image _${Math.random}`,
          tags: ["tag1"],
          folder: `/dev/council_profile/${localStorage.getItem("profile_id")}`,
        },
        (err, result) => {
          if (result) {
            if (props.ImageType === "header") {
              props
                .CouncilProfile({
                  variables: {
                    data: {
                      council_profile_photo: imageKit.url({
                        src: result.url,
                      }),
                      council_profile_path: `/dev/council_profile/${localStorage.getItem(
                        "profile_id"
                      )}`,
                    },
                    user_id: props.data?.users[0]?.id
                      ? props.data.users[0].id
                      : "",
                  },
                })
                .then(() => {
                  setCropImage(null);
                  setImageUrl(null);
                  setZoom([1]);
                  props.refetch();
                  props.onHide();
                })
                .catch(() => {});
            } else {
              props
                .CouncilProfile({
                  variables: {
                    data: {
                      council_cover_photo: imageKit.url({
                        src: result.url,
                      }),
                      council_cover_path: `/dev/council_profile/${localStorage.getItem(
                        "profile_id"
                      )}`,
                    },
                    user_id: props.data?.users[0]?.id
                      ? props.data.users[0].id
                      : "",
                  },
                })
                .then(() => {
                  setCropImage(null);
                  setImageUrl(null);
                  setCropImage(null);
                  setZoom([1]);
                  props.refetch();
                  props.onHide();
                })
                .catch(() => {});
            }
          }
        }
      );
    } else {
      props
        .CouncilProfile({
          variables: {
            data: {
              council_cover_photo: imageUrl ? imageUrl : props.currentPhoto,
              council_cover_path: `/dev/council_profile/${localStorage.getItem(
                "profile_id"
              )}`,
            },
            user_id: props.data?.users[0]?.id ? props.data.users[0].id : "",
          },
        })
        .then(() => {
          setCropImage(null);
          setImageUrl(null);
          setCropImage(null);
          setZoom([1]);
          props.refetch();
          props.onHide();
        })
        .catch(() => {});
    }
  };
  const onCropChange = (cropped) => {
    setCrop(cropped);
    showCroppedImage();
  };

  const onCropComplete = (croppedArea, croppedAreaPixelsVal) => {
    setCroppedAreaPixels(croppedAreaPixelsVal);
  };
  const onZoomChange = (zoomValue) => {
    setZoom(zoomValue);
  };

  const showCroppedImage = async () => {
    const croppedImage = await getCroppedImg(
      imageUrl ? imageUrl : props.currentPhoto,
      croppedAreaPixels
    );
    setCropImage(croppedImage);
  };
  return (
    <Modal
      className="imagecrop-modal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => setImageUrl(null)}
      ></Modal.Header>
      <Modal.Body>
        <div className="imagecrop-body">
          <h2>Background Image</h2>
          <ImageCropper
            currentPhoto={imageUrl ? imageUrl : props.currentPhoto}
            crop={crop}
            setCrop={setCrop}
            zoom={zoom}
            setZoom={setZoom}
            onCropComplete={onCropComplete}
            onCropChange={onCropChange}
            onZoomChange={onZoomChange}
          />
        </div>

        <div className="rangeslider-row">
          <div className="range-input">
            <label>Zoom</label>
            <Range
              min={1}
              max={7}
              values={zoom}
              onChange={(e) => {
                onZoomChange(e);
                showCroppedImage();
              }}
              renderThumb={({ props, isDragged }) => (
                <div className="range-circle" {...props}>
                  <div
                    style={{
                      backgroundColor: isDragged ? "#696AE7" : "#E8E9EB",
                    }}
                  />
                </div>
              )}
              renderTrack={({ props, children }) => (
                <div
                  onMouseDown={props.onMouseDown}
                  onTouchStart={props.onTouchStart}
                  style={{
                    ...props.style,
                    height: "36px",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div
                    ref={props.ref}
                    style={{
                      height: "5px",
                      width: "100%",
                      borderRadius: "4px",
                      background: getTrackBackground({
                        values: zoom,
                        colors: ["#696AE7", "#E8E9EB"],
                        min: 1,
                        max: 7,
                      }),
                      alignSelf: "center",
                    }}
                  >
                    {children}
                  </div>
                </div>
              )}
            />
            <output id="output">{zoom[0]}</output>
          </div>
          <div className="slider-title">
            <p>Drag to reposition photo</p>
          </div>
        </div>
        <div className="button-row">
          <div className="delete-btn">
            <button
              className="cancel-btn"
              onClick={() => {
                if (props.ImageType === "header") {
                  props
                    .CouncilProfile({
                      variables: {
                        data: {
                          council_profile_photo: null,
                          council_profile_path: null,
                        },
                        user_id: props.data?.users[0]?.id
                          ? props.data.users[0].id
                          : "",
                      },
                    })
                    .then(() => {
                      setImageUrl(null);
                      setZoom([1]);
                      props.refetch();
                      props.onHide();
                    })
                    .catch(() => {});
                } else {
                  props
                    .CouncilProfile({
                      variables: {
                        data: {
                          council_cover_photo: null,
                          council_cover_path: null,
                        },
                        user_id: props.data?.users[0]?.id
                          ? props.data.users[0].id
                          : "",
                      },
                    })
                    .then(() => {
                      setImageUrl(null);
                      setCropImage(null);
                      setZoom([1]);
                      props.refetch();
                      props.onHide();
                    })
                    .catch(() => {});
                }
              }}
            >
              delete Photo
            </button>
          </div>
          <div className="submit-row">
            <Upload
              type="change"
              data={props.data}
              refetch={props.refetch}
              CouncilProfile={props.CouncilProfile}
              setImageUrl={setImageUrl}
              ImageType={props.ImageType}
            />
            <div
              onClick={() => {
                handleImageUpload(cropImage);
              }}
              className="button"
              style={{ cursor: "pointer" }}
            >
              save
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ImageCrop;
